import { Suspense } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import Shimmer from '~/components/Shimmer';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { EditUserForm } from '~/features/EditUserForm';
import { EditUserHeader } from '~/features/EditUserHeader';
import { ROUTES } from '~/utils/routes';
import styles from './styles.module.scss';

/**
 * 利用者編集 Screen
 */
export const Screen: React.FC = () => {
  const { id = '' } = useParams<{ id: string }>();

  const userId = Number.parseInt(id, 10);
  if (Number.isNaN(userId)) {
    return <Navigate to={ROUTES.USERS} replace />;
  }

  return (
    <div className={styles.screen}>
      <ClientSideMenu />
      <div className={styles.content}>
        <Suspense fallback={<Shimmer />}>
          <EditUserHeader userId={userId} />
          <main className={styles.body}>
            <EditUserForm userId={userId} />
          </main>
        </Suspense>
      </div>
    </div>
  );
};
